var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d5a6c305a4b66319a9b0f35f3139eb9ea8141af0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["legacy@interpals"]={id:"d5a6c305a4b66319a9b0f35f3139eb9ea8141af0"};
      